import { Grid } from "@mui/material";
import { LinkRegistry } from "../../models";
import { useLinkRegistryQRCode } from "./useLinkRegistryQRCode";

type PrintableLinkRegistryQRListProps = {
    links: Array<LinkRegistry>;
};

export const PrintableLinkRegistryQRList = (props: PrintableLinkRegistryQRListProps) => {
    const { getQRCodeForLink } = useLinkRegistryQRCode();

    return (
        <>
            {
                props.links.map((link) => (
                    <Grid
                        item
                        xs={12}
                        display="flex"
                        justifyContent="center"
                        key={link.id}
                    >
                        <div
                            // This makes it so each QR code is on a new page when printed
                            style={{
                                pageBreakAfter: 'always',
                                breakAfter: 'page',
                                margin: 0,
                                padding: '10px',
                                width: "500px"
                            }}
                        >
                            {getQRCodeForLink(link)}
                        </div>
                    </Grid>
                ))
            }
        </>
    );
};